<div class="card stickyCard">
  <div class="card-header-white header-underline">
    <h6 class="white-header-text">
      {{ team.groupName }} ({{ team.groupId }})
    </h6>
    <span
      class="float-right cursorPointer white-header-xmark-icon"
      (click)="closeEditForm()"
      ><span class="fa-light fa-xmark"></span
    ></span>
  </div>

  <div class="card-body-white">
    <div [formGroup]="teamEditForm">
      @if (!team?.locationId && featureEnabled('DigitalKey')) {
        <div
          class="mb-2"
          >
          <ul class="list-inline">
            <li class="list-inline-item">
              <span
                class="editPageTab"
                            [ngClass]="{
                                'editPageTab-active': activeTab === 1
                            }"
                (click)="activeTab = 1"
                >{{ "INFORMATION" | translate }}</span
                >
              </li>
              <li class="list-inline-item">
                <span
                  class="editPageTab"
                            [ngClass]="{
                                'editPageTab-active': activeTab === 2
                            }"
                  (click)="activeTab = 2"
                  >{{ "LOCK_ACCESS_RIGHTS" | translate }}</span
                  >
                </li>
              </ul>
            </div>
          }
          @if (activeTab === 2) {
            <team-lock-access
              [locations]="allLocations"
              [team]="team"
            ></team-lock-access>
          }
          @if (activeTab === 1) {
            <div>
              <div class="form-group">
                <label
                  ><strong>{{ "NAME" | translate }}</strong></label
                  >
                  <input
                    class="form-control"
                    type="text"
                    placeholder="{{ team.groupName }}"
                    formControlName="groupName"
                    />
                  </div>
                  @if (team?.locationName) {
                    <div class="form-group">
                      <strong>{{ "LOCATION" | translate }}:</strong>
                      {{ team?.locationName }} ({{ team?.locationId }})
                    </div>
                  }
                  <div class="form-group">
                    <mat-slide-toggle formControlName="teamLocked"
                      >{{ "LOCKED" | translate }}
                      <span
                        matTooltip="{{ 'TOOLTIP_TEAM_LOCKED' | translate }}"
                        class="fa fa-fw fa-info-circle"
                        ></span
                      ></mat-slide-toggle>
                      @if (user.roleLevel >= 200) {
                        <mat-slide-toggle
                          formControlName="teamHidden"
                          class="ml-3"
                          >{{ "HIDDEN" | translate }}
                          <span
                            matTooltip="{{ 'TOOLTIP_TEAM_HIDDEN' | translate }}"
                            class="fa fa-fw fa-info-circle"
                            ></span
                          ></mat-slide-toggle>
                        }
                      </div>
                      <div class="form-group">
                        <label class="d-flex justify-content-between rightMargin"
                          ><strong>{{ "STAFF_MEMBERS" | translate }}</strong>
                          <mat-checkbox
                            (click)="toggleAllSelection()"
                            [labelPosition]="'before'"
                            >
                            <strong>{{ "SELECT_ALL" | translate }}</strong>
                          </mat-checkbox>
                        </label>
                        <mat-selection-list
                          #teamMembers
                          formControlName="selectedTeamMembers"
                          class="staff-container"
                          dense="true"
                          >
                          @for (staff of availableStaffForCompany; track staff) {
                            <mat-list-option
                              [value]="staff.id"
                              >
                              {{ staff.fullName }}
                            </mat-list-option>
                          }
                          @if (
                            availableStaffForLocation &&
                            availableStaffForLocation.length > 0
                            ) {
                            <span
                              matSubHeader
                              >{{ "LOCATION_MEMBERS" | translate }}</span
                              >
                          }
                          @for (staff of availableStaffForLocation; track staff) {
                            <mat-list-option
                              [value]="staff.id"
                              >
                              {{ staff.fullName }}
                            </mat-list-option>
                          }
                        </mat-selection-list>
                      </div>
                      @if (!deleteConfirmation) {
                        <div class="form-group">
                          <button
                            [disabled]="teamEditForm.invalid"
                            type="submit"
                            (click)="editTeam()"
                            class="btn btn-outline-primary gray-bg mr-1"
                            >
                            <span class="fa-light fa-floppy-disk"></span>
                            {{ "SAVE" | translate }}
                          </button>
                          <button
                            type="reset"
                            class="btn btn-outline-danger"
                            (click)="closeEditForm()"
                            >
                            <span class="fa-light fa-xmark"></span>
                            {{ "CANCEL" | translate }}
                          </button>
                          @if (user.roleLevel >= 100) {
                            <span
                              class="btn btn-outline-danger float-right cursorPointer"
                              (click)="deleteConfirmation = true"
                              ><span class="fa-light fa-trash-alt"></span>
                              {{ "DELETE" | translate }}</span
                              >
                            }
                            @if (editTeamFormError) {
                              <div
                                class="alert alert-danger mt-2"
                                >
                                {{ editTeamFormError }}
                              </div>
                            }
                          </div>
                        }
                        @if (deleteConfirmation) {
                          <div class="form-group">
                            <p>
                              {{
                              "GROUP_DELETE_CONFIRMATION"
                              | translate : { groupname: team.groupName }
                              }}
                            </p>
                            <span
                              class="btn btn-outline-danger cursorPointer"
                              (click)="deleteTeam()"
                              ><span class="fa-light fa-trash-alt"></span>
                              {{ "DELETE" | translate }}</span
                              >
                              <span
                                class="btn btn-outline-primary gray-bg ml-2 cursorPointer"
                                (click)="deleteConfirmation = false"
                                ><span class="fa-light fa-xmark"></span>
                                {{ "CANCEL" | translate }}</span
                                >
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
